import { formatClock } from '../../format';

/** Small Korean date helpers for admin/invite screens (local time zone). */

function startOfDay(date: Date): number {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
}

function dayDiff(date: Date, now: Date): number {
  return Math.round((startOfDay(now) - startOfDay(date)) / 86_400_000);
}

/** "10월 16일", with the year when it differs from `now`. */
export function formatMonthDay(value: string | Date, now: Date = new Date()): string {
  const date = new Date(value);
  const md = `${date.getMonth() + 1}월 ${date.getDate()}일`;
  return date.getFullYear() === now.getFullYear() ? md : `${date.getFullYear()}년 ${md}`;
}

/** "2026년 11월 8일" */
export function formatFullDate(value: string | Date): string {
  const date = new Date(value);
  return `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일`;
}

/** "오늘 오전 9:12", "어제 오후 4:30", otherwise "10월 7일". */
export function formatDayTime(value: string | Date, now: Date = new Date()): string {
  const date = new Date(value);
  const diff = dayDiff(date, now);
  if (diff === 0) return `오늘 ${formatClock(date)}`;
  if (diff === 1) return `어제 ${formatClock(date)}`;
  return formatMonthDay(date, now);
}

/** "방금", "5분 전", "1시간 전", "어제", "3일 전", "10월 2일". */
export function formatSince(value: string | Date, now: Date = new Date()): string {
  const date = new Date(value);
  const minutes = Math.floor((now.getTime() - date.getTime()) / 60_000);
  if (minutes < 1) return '방금';
  if (minutes < 60) return `${minutes}분 전`;
  const diff = dayDiff(date, now);
  if (diff === 0) return `${Math.floor(minutes / 60)}시간 전`;
  if (diff === 1) return '어제';
  if (diff < 7) return `${diff}일 전`;
  return formatMonthDay(date, now);
}

/** `inst_7f3a9c21d4e5…c21` → `inst_7f3a…c21` (design shorthand). */
export function shortInstanceId(instanceId: string): string {
  return instanceId.length > 14 ? `${instanceId.slice(0, 9)}…${instanceId.slice(-3)}` : instanceId;
}

/** "3,210" */
export function formatCount(value: number): string {
  return value.toLocaleString('ko-KR');
}
